export const CIMAGE_OBJECT_FIT = {
  Cover: 'cover',
  Contain: 'contain',
  Fill: 'fill',
  ScaleDown: 'scale-down',
  None: 'none',
} as const;

export type CimageObjectFit =
  (typeof CIMAGE_OBJECT_FIT)[keyof typeof CIMAGE_OBJECT_FIT];

export const CIMAGE_ANIMATION = {
  FadeBlur: 'fadeBlur',
  None: 'none',
} as const;

export type CimageAnimation =
  (typeof CIMAGE_ANIMATION)[keyof typeof CIMAGE_ANIMATION];

export const CIMAGE_BORDER_RADIUS_INHERIT = 'inherit';
export const CIMAGE_LOADING_LAZY = 'lazy';
export const CIMAGE_LOADING_EAGER = 'eager';
export const CIMAGE_DECODING_ASYNC = 'async';
export const CIMAGE_SIZE_FULL = '100%';
export const CIMAGE_SIZE_AUTO = 'auto';
export const CIMAGE_OVERFLOW_HIDDEN = 'hidden';
export const SVG_EXTENSION = '.svg';
